import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import baseURL from '../component/baseURL';
import { ReactNotifications } from 'react-notifications-component';
import showNotification from '../component/Notification';

export default function Notifications() {
    const navigate = useNavigate();
    const { t } = useTranslation();


    const [notifications, setNotifications] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const [notifCount, setNotifCount] = useState(0);
    const [userid, setUserid] = useState('');
    const [agentkey, setAgentkey] = useState('');
    const [agentID, setAgentID] = useState('');

    useEffect(() => {
        const userID = localStorage.getItem('userID');
        setUserid(userID);
        const agentkey = localStorage.getItem('agentKey');
        setAgentkey(agentkey);
        const agentid = localStorage.getItem('agentID');
        setAgentID(agentid);


        fetchNotifications(userID);
    }, []);

    function fetchNotifications(userID) {
        console.log("USER ID: " + userID);
        let formdata = new FormData();
        formdata.append("user_id", userID);
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        //formdata.append("agent_key",this.state.agentKey)

        console.log(formdata);

        fetch(baseURL.URL + "/consumers/show_notifications", {
            method: "POST",
            body: formdata,
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                const result = responseJson.response.notifications;
                console.log(result[0])
                if (responseJson.server.result_code === 200) {
                    setNotifications(result);
                    setLoadData(true);
                    if (result && result.length > 0) {
                        setNotifCount(result.length);
                    }
                } else {
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching notifications', 'danger');
            });
    }

    return (
        <>
            {/* <!-- Desktop Notification Header --> */}
            <ReactNotifications />
            <div className="notification-page-header">
                <div className="container">
                    <div className="notification-header-content">
                        <div className="notification-back-btn" aria-label="Back" onClick={() => window.history.back()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M12.5 15L7.5 10L12.5 5" stroke="#0E0E0E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <h1 className="notification-page-title">{t('notifications')}</h1>
                        <button className="desktop-mark-all-read" id="desktopMarkAllRead">{t('markAllAsRead')}</button>
                    </div>
                </div>
            </div>

            {/* <!-- Mobile Notification Header --> */}
            <header className="mobile-notification-header">
                <div className="mobile-notification-back" aria-label="Back" onClick={() => window.history.back()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
                        <path d="M11.668 23.2341C11.4486 23.2354 11.2312 23.1933 11.0281 23.1104C10.8251 23.0274 10.6404 22.9052 10.4847 22.7508L0.484654 12.7508C0.174236 12.4385 0 12.0161 0 11.5758C0 11.1355 0.174236 10.713 0.484654 10.4008L10.4847 0.400762C10.8035 0.127718 11.2136 -0.014959 11.6331 0.00124297C12.0525 0.0174449 12.4504 0.191331 12.7473 0.488156C13.0441 0.78498 13.218 1.18288 13.2342 1.60234C13.2504 2.0218 13.1077 2.43193 12.8347 2.75076L4.01799 11.5674L12.8347 20.3841C13.0687 20.6162 13.2286 20.9125 13.2943 21.2355C13.3599 21.5586 13.3283 21.8938 13.2034 22.1989C13.0786 22.5039 12.866 22.7651 12.5927 22.9494C12.3194 23.1336 11.9976 23.2327 11.668 23.2341Z" fill="black" />
                    </svg>
                </div>
                <h1 className="mobile-notification-title">{t('notifications')}</h1>
                <a href="#" className="mobile-mark-all-read" id="markAllRead">{t('markAllAsRead')}</a>
            </header>

            {/* <!-- Main Content --> */}
            <main className="main-content">
                <div className="container">
                    <div className="notification-list">
                        {/* <!-- Notification Card 1 - Unread --> */}
                        {notifications.length > 0 ? (
                            notifications.map((notification) => (
                                <div className="notification-card unread" key={notification.id}>
                                    <div className="notification-icon">
                                        <div className="notification-icon-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                <path d="M17.4167 7.33337C18.9355 7.33337 20.1667 6.10215 20.1667 4.58337C20.1667 3.06459 18.9355 1.83337 17.4167 1.83337C15.8979 1.83337 14.6667 3.06459 14.6667 4.58337C14.6667 6.10215 15.8979 7.33337 17.4167 7.33337Z" fill="#1C4CAF" />
                                                <path d="M18.15 8.635C18.1317 8.635 18.1133 8.64417 18.095 8.64417C18.0033 8.6625 17.9117 8.67167 17.8108 8.69C17.4258 8.72667 17.0133 8.70833 16.5917 8.62583C16.4817 8.59833 16.39 8.58 16.2892 8.54333C15.9867 8.47 15.7025 8.35083 15.4367 8.195C15.3267 8.14 15.2167 8.06667 15.1158 8.0025C14.6758 7.7 14.3 7.32417 13.9975 6.88417C13.9333 6.78333 13.86 6.67333 13.805 6.56333C13.6492 6.2975 13.53 6.01333 13.4567 5.71083C13.42 5.61 13.4017 5.51833 13.3742 5.40833C13.2917 4.98667 13.2733 4.57417 13.31 4.18917C13.3283 4.08833 13.3375 3.99667 13.3558 3.905C13.3558 3.88667 13.365 3.86833 13.365 3.85C13.475 3.28167 13.0533 2.75 12.4667 2.75H6.89334C6.76501 2.75 6.63668 2.75917 6.51751 2.76833C6.40751 2.7775 6.30668 2.78667 6.19668 2.805C6.08668 2.81417 5.97668 2.8325 5.87584 2.85083C3.66668 3.17167 2.25501 4.57417 1.93418 6.7925C1.91584 6.89333 1.89751 7.00333 1.88834 7.11333C1.87001 7.22333 1.86084 7.32417 1.85168 7.43417C1.84251 7.55333 1.83334 7.68167 1.83334 7.81V15.1067C1.83334 15.235 1.84251 15.3633 1.85168 15.4825C1.86084 15.5925 1.87001 15.6933 1.88834 15.8033C1.89751 15.9133 1.91584 16.0233 1.93418 16.1242C2.25501 18.3425 3.66668 19.745 5.87584 20.0658C5.97668 20.0842 6.08668 20.1025 6.19668 20.1117C6.30668 20.13 6.40751 20.1392 6.51751 20.1483C6.63668 20.1575 6.76501 20.1667 6.89334 20.1667H14.19C14.3183 20.1667 14.4467 20.1575 14.5658 20.1483C14.6758 20.1392 14.7767 20.13 14.8867 20.1117C14.9967 20.1025 15.1067 20.0842 15.2075 20.0658C17.4167 19.745 18.8283 18.3425 19.1492 16.1242C19.1675 16.0233 19.1858 15.9133 19.195 15.8033C19.2133 15.6933 19.2225 15.5925 19.2317 15.4825C19.2408 15.3633 19.25 15.235 19.25 15.1067V9.53333C19.25 8.94667 18.7183 8.525 18.15 8.635ZM6.18751 11.4583H10.7708C11.1467 11.4583 11.4583 11.77 11.4583 12.1458C11.4583 12.5217 11.1467 12.8333 10.7708 12.8333H6.18751C5.81168 12.8333 5.50001 12.5217 5.50001 12.1458C5.50001 11.77 5.81168 11.4583 6.18751 11.4583ZM14.4375 16.5H6.18751C5.81168 16.5 5.50001 16.1883 5.50001 15.8125C5.50001 15.4367 5.81168 15.125 6.18751 15.125H14.4375C14.8133 15.125 15.125 15.4367 15.125 15.8125C15.125 16.1883 14.8133 16.5 14.4375 16.5Z" fill="#1C4CAF" />
                                            </svg>
                                            <div className="notification-dot"></div>
                                        </div>
                                    </div>
                                    <div className="notification-content">
                                        <h3 className="notification-title">{notification.title}</h3>
                                        <p className="notification-description">{notification.description}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="no-notification-message text-center">
                                <p>{t('noNotifications')}</p>
                            </div>
                        )}

                    </div>
                </div>
            </main>
        </>
    );
}